import { DiscreteValueOption, ReportTypes } from '@mode/shared/contract-common';
import { SingleValueFilterControl, SingleValueSelection } from '@mode/filters/util';

const OPTION_COUNT_SEARCH_MIN = 12;

export default class FilterModuleSingleController {
  static $inject = [];

  filter: SingleValueFilterControl;
  filterOpts: ReportTypes.SingleSelectFilterOptions;
  selected: SingleValueSelection;
  options: DiscreteValueOption[];

  // Interaction
  onSelection: ($args: {
    $filter: SingleValueFilterControl;
    $selection: ReportTypes.DiscreteFilterSelectionTypes;
  }) => void;

  filterPattern = '';

  get position(): number {
    return this.filter.position;
  }
  $onChanges($changes: angular.IOnChangesObject) {
    if ($changes.filter && $changes.filter.currentValue != null) {
      this.selected = this.filter.selected;
    }

    if ($changes.filterOpts && this.filterOpts != null) {
      this.options = this.filterOpts.values.map((o) => new DiscreteValueOption(o));
    }
  }

  isSelected(option: ReportTypes.ReportFilterValue) {
    if (this.selected.all) {
      return false;
    } else {
      return this.selected.value === option;
    }
  }

  selectOption(option: ReportTypes.ReportFilterValue) {
    this.selected = this.selected.with({
      all: false,
      value: option,
    });

    this.onSelection({
      $filter: this.filter,
      $selection: { type: ReportTypes.DiscreteSelectionType.Select, value: option, selected: true },
    });
  }

  selectAllOption() {
    this.selected = this.selected.with({
      all: true,
      value: null,
    });

    this.onSelection({ $filter: this.filter, $selection: { type: ReportTypes.DiscreteSelectionType.All } });
  }

  get isAllSelectable() {
    return this.filter.hideSelectAll !== true;
  }

  minimumOptionsAvailable(): boolean {
    return this.options?.length >= OPTION_COUNT_SEARCH_MIN;
  }
}
